module.exports = __webpack_public_path__ + "img/footer-image.75f05733.png";